import React from 'react';
import FullScreenVerticalCenterContent from '../../styledhtml/FullScreenVerticalCenterContent';
import Navigation from '../../services/Navigation';
import StatefulButton from '../../components/StatefulButton';
import LogictryComponent from '../../submodules/logictry_config/LogictryComponent';

export default class LoginToViewPage extends LogictryComponent {
  render() {
    return (
      <FullScreenVerticalCenterContent fullscreenHeight>
        <div>
          <h1 style={{ textAlign: 'center', marginBottom: '2rem' }}>You must login to view</h1>
          <StatefulButton text="Go to Login" onClick={() => Navigation.push(Navigation.login)} />
        </div>
      </FullScreenVerticalCenterContent>
    );
  }
}
